module.exports = "pegasus_template/assets/theme4/facebook-icon-1.png";